import { EventBus } from '@/ui/EventBus';
import { Events } from '@/ui/events';
import { onUnmounted, Ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { filterListToOptions, toasted } from '@/ui/helpers';
import { t } from '../i18n/i18n';
import { CreateUserModelIdentifier } from '@/ui/components/user/CreateUserModal';
import { filter as getAllUsers } from '@/services/api/resources/user';
import { SelectOptions } from '@/ui/types';

type addUserToRecordFn = (id: number) => void;
type userFillInFnDefinition = (data: { data: BaseFilterEntity[] }) => SelectOptions<string | number>;

export function useCreatableUserModal<T = number | string>(
  users: Ref<SelectOptions<number | string>>,
  addUserToRecord: addUserToRecordFn = () => {},
  usersFillFn: userFillInFnDefinition = filterListToOptions,
) {
  const getUsers = useTask(
    () => getAllUsers(),
    usersResponse => {
      users.value = usersFillFn(usersResponse);
    },
  );

  const onUserCreated = async ({ response: r }: { response: { id: number }; identifier: CreateUserModelIdentifier }) => {
    toasted.success(t('user.created'), { duration: 5000 });

    // Fetch all users to fill dropdown with new information
    await getUsers.run();

    addUserToRecord(r.id);
  };

  const unregisterListeners = () => {
    EventBus.$off(Events.userCreated, onUserCreated);
  };

  EventBus.$on(Events.userCreated, onUserCreated);

  onUnmounted(unregisterListeners);
}
